import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'
import { useAuth } from './hooks/useAuth'
import Sidebar from './components/common/sidebar/Sidebar'
import LoginPage from './pages/LoginPage'
import StubPage from './pages/DashboardPageNew'
import CreateProject from './pages/projects/CreateProject'
import EditProject from './pages/projects/EditProject'
import ProjectDetail from './pages/projects/ProjectDetail'
import KanbanBoard from './pages/kanban/KanbanBoard'
import TelegramLogs from './pages/telegram/TelegramLogs'
import ProjectsList from './pages/projects/ProjectsList'
import PasswordPage from "@/pages/password/PasswordPage.jsx";

import './App.css'
import KeysPage from "@/pages/vpn/KeysPage.jsx";
import DashboardPage from "@/pages/vpn/DashboardPage.jsx";
import KeyHistoryPage from "@/pages/vpn/KeyHistoryPage.jsx";
import BrowserPage from "@/pages/browser/BrowserPage.jsx";
import EmailPage from "@/pages/email/EmailPage.jsx";
import BackupsPage from "@/pages/backups/BackupsPage.jsx";
import ValheimPage from "@/pages/projects/ValheimPage.jsx";
import EhealthPage from "@/pages/ehealth/EhealthPage.jsx";
import OzonEventsPage from "@/pages/ozonEvents/OzonEventsPage.jsx";

const { Content } = Layout

function App() {
  const { isAuthenticated } = useAuth()
  // Защищенный роут
  const PrivateRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" />
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout>
        {isAuthenticated && <Sidebar />}
        <Content>
          <Routes>
            {/* Публичные роуты */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Защищенные роуты */}
            <Route path="/" element={
              <PrivateRoute>
                <StubPage />
              </PrivateRoute>
            } />


            <Route path="/projects" element={
              <PrivateRoute>
                <ProjectsList />
              </PrivateRoute>
            } />

            <Route path="/projects/new" element={
              <PrivateRoute>
                <CreateProject />
              </PrivateRoute>
            } />

            <Route path="/projects/:uuid" element={
              <PrivateRoute>
                <ProjectDetail />
              </PrivateRoute>
            } />

            <Route path="/projects/:uuid/edit" element={
              <PrivateRoute>
                <EditProject />
              </PrivateRoute>
            } />

            <Route path="/projects/:uuid/kanban" element={
              <PrivateRoute>
                <KanbanBoard />
              </PrivateRoute>
            } />

            <Route path="/projects/:uuid/tg-logs" element={
              <PrivateRoute>
                <TelegramLogs />
              </PrivateRoute>
            } />

            <Route path="/projects/:uuid/passwords" element={
              <PrivateRoute>
                <PasswordPage />
              </PrivateRoute>
            } />

            <Route path="/projects/:uuid/backups" element={
              <PrivateRoute>
                <BackupsPage />
              </PrivateRoute>
            } />

            <Route path="/projects/:uuid/valheim" element={
              <PrivateRoute>
                <ValheimPage />
              </PrivateRoute>
            } />

            <Route path="/backups" element={
              <PrivateRoute>
                <BackupsPage />
              </PrivateRoute>
            } />

            {/* VPN */}
            <Route path="/services/vpn" element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            } />

            <Route path="/services/vpn/keys" element={
              <PrivateRoute>
                <KeysPage />
              </PrivateRoute>
            } />

            <Route path="/services/vpn/keys/:keyId" element={
              <PrivateRoute>
                <KeyHistoryPage />
              </PrivateRoute>
            } />

            {/* Ozon Browser */}
            <Route path="/services/ozon-browser" element={
              <PrivateRoute>
                <BrowserPage />
              </PrivateRoute>
            } />

            <Route path="/services/ozon-events" element={
              <PrivateRoute>
                <OzonEventsPage />
              </PrivateRoute>
            } />

            <Route path="/services/ehealth" element={
              <PrivateRoute>
                <EhealthPage />
              </PrivateRoute>
            } />

            {/* Почта */}
            <Route path="/services/email" element={
              <PrivateRoute>
                <EmailPage />
              </PrivateRoute>
            } />

            {/* Редирект */}
            <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  )
}

export default App